module.exports = __webpack_public_path__ + "static/media/benefit-easy.f3f7944e.png";